import { FileName } from './FileName';

export function getFileNameFromPath(filenameOrPath: string): FileName {
    return FileName.from(filenameOrPath.split(/[\\/]/).pop()?.trim() ?? '');
}
